'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const IaqChart = dynamic(() => import('@/app/customer-success/components/IaqBarChart'), { ssr: false });

const iaqProducts = [
  { id: 'iaq-uv', product: 'UV Air Purification', homes: 38, avgValue: '$1,800', totalValue: '$68,400', qualified: 38, proposed: 24, accepted: 8, pct: 21 },
  { id: 'iaq-media', product: 'Media Filtration Upgrade', homes: 27, avgValue: '$1,800', totalValue: '$48,600', qualified: 27, proposed: 18, accepted: 6, pct: 22 },
  { id: 'iaq-humid', product: 'Whole-Home Humidifier', homes: 18, avgValue: '$2,200', totalValue: '$39,600', qualified: 18, proposed: 11, accepted: 4, pct: 22 },
  { id: 'iaq-purif', product: 'iWave Air Purification', homes: 10, avgValue: '$2,900', totalValue: '$29,000', qualified: 10, proposed: 7, accepted: 3, pct: 30 },
];

export default function IaqOpportunitiesPanel() {
  return (
    <div className="bg-card rounded-lg card-shadow border border-border">
      <div className="px-5 py-4 border-b border-border flex items-center justify-between">
        <div>
          <h3 className="text-sm font-semibold text-foreground">Indoor Air Quality Opportunities</h3>
          <p className="text-xs text-muted-foreground mt-0.5">93 qualified homes · $186,000 projected revenue</p>
        </div>
        <div className="text-right">
          <div className="text-xs text-muted-foreground">Conversion rate</div>
          <div className="text-xs font-semibold text-success">23% avg close rate</div>
        </div>
      </div>
      <div className="px-5 py-4">
        <IaqChart />
        <div className="mt-4 space-y-3">
          {iaqProducts?.map((p) => (
            <div key={p?.id} className="border border-border rounded-md p-3">
              <div className="flex items-center justify-between mb-2">
                <span className="text-xs font-semibold text-foreground">{p?.product}</span>
                <span className="text-sm font-bold text-success font-tabular">{p?.totalValue}</span>
              </div>
              <div className="grid grid-cols-4 gap-2 text-xs">
                <div>
                  <div className="text-muted-foreground">Qualified</div>
                  <div className="font-semibold font-tabular text-foreground">{p?.qualified}</div>
                </div>
                <div>
                  <div className="text-muted-foreground">Proposed</div>
                  <div className="font-semibold font-tabular text-secondary">{p?.proposed}</div>
                </div>
                <div>
                  <div className="text-muted-foreground">Accepted</div>
                  <div className="font-semibold font-tabular text-success">{p?.accepted}</div>
                </div>
                <div>
                  <div className="text-muted-foreground">Close%</div>
                  <div className="font-semibold font-tabular text-accent">{p?.pct}%</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}